<template>
  <main>
    <mdb-container fluid>
      <h1 class="sr-only">{{ $t('gallery.heading') }}</h1>
      <content-status
        v-if="!hasAlbums"
        :empty-message="$t('gallery.empty')"
        :error-message="$t('gallery.load_error')"
        :failed="albums.error"
        :loading="isLoading"
        :loading-label="$t('site.loading')"
        @retry="load"
      />

      <mdb-row v-else class="mt-3" data-cy="intro-albums">
        <mdb-col
          v-for="(album, index) in list"
          :key="album.slug"
          :style="{ animationDelay: `${index * 0.2}s` }"
          class="mb-3 pentagon-album-column"
          data-cy="intro-album"
          md="4"
          sm="12"
        >
          <Album :album="album"/>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </main>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol } from 'mdbvue';
import { mapState } from 'vuex';
import Album from '../../components/Album.vue';
import ContentStatus from '../../components/ContentStatus.vue';

export default {
  name: 'Gallery',
  components: {
    Album,
    ContentStatus,
    mdbRow,
    mdbCol,
    mdbContainer,
  },
  computed: {
    ...mapState('intro', ['albums']),
    list() {
      return this.albums.data || [];
    },
    hasAlbums() {
      return this.list.length > 0;
    },
    // The request starts in created(), so "no data and no error" can only mean it is on its way.
    isLoading() {
      return !this.albums.data && !this.albums.error;
    },
  },
  created() {
    this.$store.commit('TOGGLE_OFF_NAVBAR_TRANSPARENT');
    this.load();
  },
  methods: {
    load() {
      this.$store.dispatch('intro/fetchAlbums');
    },
  },
};
</script>

<style>
  /* The cards enter one after the other: the delay is set per column. */
  .pentagon-album-column .pentagon-album {
    animation-delay: inherit;
    animation-fill-mode: both;
  }
</style>
